document.addEventListener('DOMContentLoaded', function() {
  const triggers = document.querySelectorAll('.brand-logos__wrapper');
  
  triggers.forEach(function(trigger) {
    const container = trigger.querySelector('.m-popup-container') || 
                     trigger.closest('.block-container').querySelector('.m-popup-container');
    
    const closeButton = container.querySelector('.m-close-svg');

    trigger.addEventListener('click', function() {
      console.log("Trigger clicked");
      if (container) {
        container.style.display = 'block';
      }
    });

    if (closeButton) {
      closeButton.addEventListener('click', function(e) {
        e.stopPropagation(); 
        container.style.display = 'none';
      });
    }
  });
});